/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import {
    Container, Card
} from '@material-ui/core';
import SearchNotFound from '../../../SearchNotFound';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button, Chip, FormControl, Checkbox, FormHelperText } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import ClearIcon from '@mui/icons-material/Clear';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import services from '../Services';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

var screenCode = "REALLOCATIONBREAKDOWNREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'createdDate',
        numeric: false,
        disablePadding: false,
        label: 'Date',
        align: "left",
        disableSort: true
    },
    {
        id: 'productCode',
        numeric: false,
        disablePadding: false,
        label: 'SKU Code',
        align: "left"
    },
    {
        id: 'productName',
        numeric: false,
        disablePadding: false,
        label: 'SKU Description',
        align: "left"
    },
    {
        id: 'factoryName',
        numeric: false,
        disablePadding: false,
        label: 'Re-allocated FCC',
        align: "left"
    },
    {
        id: 'quantity',
        numeric: true,
        disablePadding: false,
        label: 'Re-allocated Quantity',
        align: "right"
    },
    {
        id: 'acceptedQuantity',
        numeric: true,
        disablePadding: false,
        label: 'Accepted Quantity',
        align: "right"
    },
    {
        id: 'remainingQuantity',
        numeric: true,
        disablePadding: false,
        label: 'Remaining Quantity',
        align: "right"
    },
    {
        id: 'returnQuantity',
        numeric: true,
        disablePadding: false,
        label: 'Return Quantity',
        align: "right"
    },
];
function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        {headCell.disableSort ? (
                            headCell.label
                        ) : (
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        )}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function OrderReallocationBreakdownReport(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);

    const classes = useStyles();
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('createdDate');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Order Reallocation Breakdown Report'
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());
    const [cropTransaction, setCropTransaction] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);

    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: '',
        productCategoryID: '',
        cropID: '',
        fromDate: '',
        toDate: '',
        isActive: true
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const cropAvailabilitySchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array().min(1, 'Please Select at least One Fresh Collection Center').required('Please Select at least One Fresh Collection Center'),
        productCategoryID: Yup.array().min(1, 'Please Select at least One Product Category').required('Please Select at least One Product Category'),
        cropID: Yup.array().min(1, 'Please Select at least One Product').required('Please Select at least One Product'),
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        productCategoryID: '',
        cropID: '',
        toDate: '',
        fromDate: ''
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            productCategoryID: selectedCategoryOptions,
            cropID: selectedProductOptions,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            isActive: formData.isActive
        },
        validationSchema: cropAvailabilitySchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
    });

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWREALLOCATIONBREAKDOWNREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
    }

    async function SubmitForm() {
        try {
            let model = {
                operationEntityID: selectedOptions.map(x => x).join(',').toString(),
                productCategoryID: selectedCategoryOptions.map(x => x).join(',').toString(),
                cropID: selectedProductOptions.map(x => x).join(',').toString(),
                fromDate: (fromDate).toISOString(),
                toDate: (toDate).toISOString(),
            };
            let newRes = await services.GetOrderReallocationBreakdownReport(model);

            if (!newRes || newRes.length === 0) {
                setCropTransaction([]);
                toast.warning('No data found for the selected criteria');
                return;
            }

            let final = newRes.filter(x => x.quantity > 0 || x.quantity !== null);
            let res = _.cloneDeep(final);

            setCropTransaction(res);
            createDataForExcel(res);
            getSelectedDropdownVluesForReport();

            if (res.length === 0) {
                toast.info('No records match your search criteria');
            }
        } catch (error) {
            toast.error('Error fetching report data');
            setCropTransaction([]);
        }
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(GetProductCategoties());
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        trackPromise(GetProductDetails());
    }, [selectedCategoryOptions]);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
        setFromDate(new Date());
        setToDate(new Date());
    }, [formik.values.groupID]);

    useEffect(() => {
        setCropTransaction([]);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setCropTransaction([]);
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        setCropTransaction([]);
    }, [formik.values.cropID]);

    useEffect(() => {
        setCropTransaction([]);
    }, [toDate]);

    useEffect(() => {
        setCropTransaction([]);
    }, [fromDate]);

    useEffect(() => {
        setCropTransaction([]);
    }, [selectedOptions]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions
        })
    }, [selectedOptions]);

    useEffect(() => {
        setCropTransaction([]);
    }, [selectedCategoryOptions])

    useEffect(() => {
        setValues({
            ...values,
            cropID: selectedProductOptions
        })
    }, [selectedProductOptions]);

    useEffect(() => {
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    }, [selectedOptions]);

    useEffect(() => {
        setSelectedProductOptions([]);
    }, [selectedCategoryOptions]);

    useEffect(() => {
        setValues({
            ...values,
            productCategoryID: selectedCategoryOptions
        })
    }, [selectedCategoryOptions]);

    useEffect(() => {
        setCropTransaction([]);
    }, [selectedProductOptions])

    useEffect(() => {
        if (selectedOptions.length > 0 && selectedCategoryOptions.length > 0) {
            trackPromise(GetProductDetails())
        }
    }, [selectedCategoryOptions, selectedOptions])

    useEffect(() => {
        if (selectedOptions.length == 0) {
            setProductcatogery([])
        } else {
            trackPromise(GetProductCategoties())
        }
    }, [selectedOptions])

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties()
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productCategoryName, value: res[i].productCategoryID })
            }
            setProductcatogery(newOptionArray);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(
            selectedOptions.map(x => x).join(','),
            selectedCategoryOptions.map(x => x).join(",")
        )
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productName, value: res[i].productID })
            }
            setProduct(newOptionArray);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        let res = await services.GetVCCFactoriesByGroupID(formik.values.groupID);
        var newOptionArray = [];
        for (var i = 0; i < res.length; i++) {
            newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
        }
        setFactory(newOptionArray);
    }

    async function clearAll() {
        if (permissionList.isFactoryFilterEnabled) {
            setCropTransaction([]);
            setValues({
                ...values,
                operationEntityID: '',
                productCategoryID: '',
                cropID: '',
            })
            setToDate(new Date());
            setFromDate(new Date());
            setSelectedCategoryOptions([]);
            setSelectedProductOptions([]);
            setSelectedOptions([]);
        } else {
            setValues({
                ...values,
                productCategoryID: '',
                cropID: '',
            })
            setSelectedCategoryOptions([]);
            setSelectedProductOptions([]);
            setToDate(new Date());
            setFromDate(new Date());
        }
    }

    //Print
    async function createFile() {
        var file = await createDataForExcel(cropTransaction);
        var settings = {
            sheetName: 'Reallocation Breakdown Report',
            fileName: 'Order Reallocation Breakdown Report_' + new Date(fromDate).toISOString().split('T')[0] + '-' + new Date(toDate).toISOString().split('T')[0],
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Crop Wise Transaction',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(selectedOptions.length === factory.length ? [] : factory.map((option) => option.value));
        } else {
            setSelectedOptions(value);
        }
        setFromDate(new Date());
        setToDate(new Date());
    };

    const handleSelectCategoryChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedCategoryOptions(selectedCategoryOptions.length === productcatogery.length ? [] : productcatogery.map((option) => option.value));
        } else {
            setSelectedCategoryOptions(value);
        }
        setFromDate(new Date());
        setToDate(new Date());
    };

    const handleSelectProductChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedProductOptions(selectedProductOptions.length === product.length ? [] : product.map((option) => option.value));
        } else {
            setSelectedProductOptions(value);
        }
        setFromDate(new Date());
        setToDate(new Date());
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
        setFromDate(new Date());
        setToDate(new Date());
    };
    const handleClearCategorySelection = () => {
        setSelectedCategoryOptions([]);
        setFromDate(new Date());
        setToDate(new Date());
    };
    const handleClearProductSelection = () => {
        setSelectedProductOptions([]);
        setFromDate(new Date());
        setToDate(new Date());
    };

    async function createDataForExcel(array) {
        var res = [];
        if (array != null && array.length > 0) {
            array.map(x => {
                var vr = {
                    'Date': x.createdDate ? new Date(x.createdDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) : '-',
                    'SKU Code': x.productCode,
                    'SKU Description': x.productName,
                    'Re-allocated FCC': x.factoryName,
                    'Re-allocated Quantity(Kg)': x.quantity,
                    'Accepted Quantity(Kg)': x.accepetQuantity,
                    'Remaining Quantity(Kg)': x.remainingQuantity,
                    'Return Quantity(Kg)': x.returnQuantity,

                }
                res.push(vr);
            });

            res.push({});
            res.push({});
        }
        return res;
    }

    function getSelectedDropdownVluesForReport() {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });

        const categoryName = [];
        selectedCategoryOptions.forEach(x => {
            const filterCategory = productcatogery.find(y => x === y.value).label
            categoryName.push(filterCategory);
        })

        const productName = [];
        selectedProductOptions.forEach(x => {
            const filterProduct = product.find(y => x === y.value).label
            productName.push(filterProduct);
        })

        let groups = group.find(x => x.groupID == formik.values.groupID)
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(','),
            productCategoryID: categoryName.length == 0 ? 'All Product Categories' : categoryName.join(', '),
            cropID: productName.length == 0 ? 'All Products' : productName.join(',')
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderCategorySelectedValue = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = productcatogery.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderProductSelectedValue = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = product.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Order Reallocation Breakdown Report |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/OrderReallocationBreakdownReport"}
                        btname="Add"
                        pageName="Order Reallocation Breakdown Report"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>

                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}

                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {
                                            selectedOptions.length > 0 && (
                                                <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                    {!permissionList.isFactoryFilterEnabled ? null :
                                                        <ClearIcon />}
                                                </IconButton>
                                            )
                                        }
                                    </FormControl>

                                    <FormControl fullWidth error={Boolean(touched.productCategoryID && errors.productCategoryID)}>
                                        <InputLabel id="multi-select-label">Product Category * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedCategoryOptions}
                                            onChange={handleSelectCategoryChange}
                                            label="Product Category "
                                            disabled={selectedOptions.length === 0}
                                            renderValue={(selected) => renderCategorySelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedCategoryOptions.length === productcatogery.length} color="primary" />
                                                All Product Category
                                            </MenuItem>
                                            {productcatogery.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedCategoryOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.productCategoryID && errors.productCategoryID && (
                                            <FormHelperText>{errors.productCategoryID}</FormHelperText>
                                        )}
                                        {
                                            selectedCategoryOptions.length > 0 && (
                                                <IconButton onClick={handleClearCategorySelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                    <ClearIcon />
                                                </IconButton>
                                            )
                                        }
                                    </FormControl>

                                    <FormControl fullWidth error={Boolean(touched.cropID && errors.cropID)}>
                                        <InputLabel id="multi-select-label">Product * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedProductOptions}
                                            onChange={handleSelectProductChange}
                                            label="Product "
                                            disabled={selectedOptions.length === 0 && selectedCategoryOptions.length === 0}
                                            renderValue={(selected) => renderProductSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedProductOptions.length === product.length} color="primary" />
                                                All Products
                                            </MenuItem>
                                            {product.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedProductOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.cropID && errors.cropID && (
                                            <FormHelperText>{errors.cropID}</FormHelperText>
                                        )}
                                        {
                                            selectedProductOptions.length > 0 && (
                                                <IconButton onClick={handleClearProductSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                    <ClearIcon />
                                                </IconButton>
                                            )
                                        }
                                    </FormControl>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select Start Date *"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}
                                                {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select End Date *"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}
                                                {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <div>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color='error'
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </div>
                                </Stack>
                            </Stack>
                            <br />
                            <>
                                {cropTransaction.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '100rem' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer>
                                                        <Table
                                                            className={classes.table}
                                                            aria-labelledby="tableTitle"
                                                            aria-label="enhanced table"
                                                        >
                                                            <EnhancedTableHead
                                                                classes={classes}
                                                                order={order}
                                                                orderBy={orderBy}
                                                                onRequestSort={handleRequestSort}
                                                                rowCount={cropTransaction.length}
                                                            />
                                                            <TableBody>
                                                                {stableSort(cropTransaction, getComparator(order, orderBy))
                                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                    .map((row, index) => {
                                                                        const labelId = `enhanced-table-checkbox-${index}`;

                                                                        return (
                                                                            <TableRow>
                                                                                <TableCell >{row.createdDate ? new Date(row.createdDate).toLocaleDateString('en-US',
                                                                                    { year: 'numeric', month: '2-digit', day: '2-digit' }) : '-'}
                                                                                </TableCell>
                                                                                <TableCell component="th" id={labelId} scope="row" >
                                                                                    {row.productCode}
                                                                                </TableCell>
                                                                                <TableCell >{row.productName}</TableCell>
                                                                                <TableCell >{row.factoryName}</TableCell>
                                                                                <TableCell align='right'>{row.quantity ? parseFloat(row.quantity).toFixed(2) : '0.00'}</TableCell>
                                                                                <TableCell align='right'>{row.accepetQuantity ? parseFloat(row.accepetQuantity).toFixed(2) : '0.00'}</TableCell>
                                                                                <TableCell align='right'>{row.remainingQuantity ? parseFloat(row.remainingQuantity).toFixed(2) : '0.00'}</TableCell>
                                                                                <TableCell align='right'>{row.returnQuantity ? parseFloat(row.returnQuantity).toFixed(2) : '0.00'}</TableCell>
                                                                            </TableRow>
                                                                        );
                                                                    })}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>

                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 25]}
                                                        component="div"
                                                        count={cropTransaction.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                            </Card>
                                        </Stack>
                                    </>
                                ) : <SearchNotFound searchQuery="Order Reallocation Breakdown Report" />}</>
                        </Form>
                    </FormikProvider>
                    {cropTransaction.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Order Reallocation Breakdown Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    productList={cropTransaction}
                                    searchData={selectedSearchValues}

                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}